<template>
  <div :class="$style.cardsStaticCoin">
    <div :class="$style.title">
      {{  $t('cards.home.'+type) }}
    </div>
    <div :class="$style.list">
    <div v-for="(item, index) in data" :key="index" :class="$style.card">
      <img :src="item.iconUrl" :class="$style.pic" />
      <div :class="$style.name">{{item.crypto}}</div>
      <div :class="$style.fullname">{{item.cryptoFullName || item.crypto }}</div>
    </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CryptoShowI } from '~/api/cards/backend';
// 该接口数据缓存至本地
const props = defineProps({
  'type': String,
  'data': Array<CryptoShowI>
});


</script>

<style lang="less" module>
.cardsStaticCoin{
  margin-bottom: 40px;
  .title{
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .list{
    display: flex;
    flex-wrap: wrap;
    gap: 8px;

  }
  .card{
    width: 180px;
    display: flex;
    background: #F9FBFD;
    padding: 12px;
    box-sizing: border-box;
    border-radius: 4px;
    align-items: center;
    transition: all 0.3s ease;
    
    @media screen and (max-width: 768px) {
      width: calc(50% - 8px);
    }
  }
  .pic{
    width: 24px;
    height: 24px;
    border-radius: 12px;
    overflow: hidden;
    flex-grow: 0;
    flex-shrink: 0;
  }
  .name{
    font-size: 16px;
    font-weight: 500;
    margin: 0 4px 0 8px;
    flex-shrink: 0;
  }
  .fullname{
    min-width: 10px;
    font-size: 12px;
    color: #6A7C81;
    padding-top: 2px; 
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>